<template>
  <div>
      <main class="main main--dark main--dashboard">
          <div class="content">
              <template v-if="$store.state.user.approve_status == null">
                  <div class="block-info">
                      <h3 class="heading3">Your company profile must be completed</h3>
                      <p class="mt-4">In order to have your account approved you need to complete your company's profile</p>
                      <button class="button" @click="openCompanyProfile">Complete Profile</button>
                  </div>
              </template>

              <template v-else-if="$store.state.user.approve_status == 'in_review'">
                  <div class="block-info">
                      <h3 class="heading3">Your account is currently pending review.</h3>
                      <p class="mt-4">A SwitchPitch representative will review your account within 1 business day and you will be notified when
                      it's been approved.</p>
                  </div>
              </template>

              <template v-else-if="$store.state.user.approve_status == 'approved'">
                  <template v-if="startupsLoaded">

                      <div class="startup-placeholder" v-if="addedStartupsCount == 0">
                          <div class="startup-placeholder__inner">
                              <h3 class="heading3">Add Your Startups To Get Started</h3>
                              <p>Once you've listed your startups, you can fill out their<br/> profiles and share them with enterprise companies.</p>
                              <button class="button" @click="addStartup">Add Startups</button>
                          </div>
                      </div>

                      <template v-else>
                          <section class="dashboard dashboard--startups">
                              <header class="dashboard__header">
                                  <h3 class="heading3">Startups Activity</h3>
                                  <a v-if="false" href="#" class="dashboard__actions"></a>
                              </header>

                              <div class="dashboard__content">
                                  <ul class="dashboard__stats">
                                      <li>
                                          <div class="dashboard__stats__counter">
                                              <animated-number
                                                  :value="addedStartupsCount"
                                                  :duration="500"
                                                  :round="true"
                                              />
                                          </div>
                                          <p>Startups added</p>
                                      </li>

                                      <li>
                                          <div class="dashboard__stats__counter">
                                              <animated-number
                                                  :value="appliedStartupsCount"
                                                  :duration="500"
                                                  :round="true"
                                              />
                                          </div>
                                          <p>Applied to challenges</p>
                                      </li>
                                  </ul>

                                  <div class="dashboard__content__inner" v-if="recentlyAddedStartups.length">
                                      <b-row>
                                          <b-col sm="6">
                                              <h4 class="heading4">Recently added startups</h4>
                                              <ul class="rows-list recentlyAddedStartups">
                                                  <li v-for="startup in recentlyAddedStartups" :key="startup.id">
                                                      <figure class="image-block image-block--xs">
                                                          <img :src="LogoHelper.getLogo(startup.logo_url)" alt=""/>
                                                      </figure>
                                                      <div>
                                                          <h5 class="heading5"><a :href="'/startups/' + startup.id" target="_blank">{{ startup.name }}</a></h5>
                                                      </div>
                                                  </li>
                                              </ul>
                                          </b-col>
                                      </b-row>
                                  </div>
                              </div>
                          </section>

                          <section class="dashboard dashboard--startups">
                              <header class="dashboard__header">
                                  <h3 class="heading3">Enterprises Activity</h3>
                                  <a v-if="false" href="#" class="dashboard__actions"></a>
                              </header>

                              <div class="dashboard__content">
                                  <ul class="dashboard__stats">
                                      <li>
                                          <div class="dashboard__stats__counter">
                                              <animated-number
                                                  :value="enterprisesCount.invited"
                                                  :duration="500"
                                                  :round="true"
                                              />
                                          </div>
                                          <p>Enterprises invited (pending)</p>
                                      </li>

                                      <li>
                                          <div class="dashboard__stats__counter">
                                              <animated-number
                                                  :value="enterprisesCount.connected"
                                                  :duration="500"
                                                  :round="true"
                                              />
                                          </div>
                                          <p>Enterprises connected</p>
                                      </li>
                                  </ul>

                                  <div class="dashboard__content__inner" v-if="enterprisesLoaded && enterprisesCount.invited == 0 && enterprisesCount.connected == 0">
                                      <div class="dashboard__content__placeholder">
                                          <h3 class="heading3">See Enterprise Activity</h3>
                                          <p>When you connect enterprises, you'll see connection status here.</p>
                                          <button class="button" @click="addEnterprise">Add Connection</button>
                                      </div>
                                  </div>
                              </div>
                          </section>
                      </template>
                  </template>

              </template>
          </div>

          <aside class="aside">
              <div class="aside__inner">
                  <div class="aside__inner__section">
                      <div class="image-block">
                          <img :src="LogoHelper.getLogo($store.state.user.company_logo)" alt="img"/>
                      </div>
                      <h4 class="heading4">{{ $store.state.user.company_name }}</h4>
                      <template v-if="$store.getters.isEnterprise">Enterprise</template>
                      <p><a :href="$store.state.user.company_url" target="_blank">{{$store.state.user.company_website}}</a></p>
                  </div>
              </div>
          </aside>
      </main>
  </div>
</template>

<script>

import AnimatedNumber from "animated-number-vue"
import dashboard from "@/services/ecosystem/dashboard.service";

export default {
    components: {
        AnimatedNumber
    },

    data() {
        return {
            addedStartupsCount: 0,
            startupsLoaded: false,
            appliedStartupsCount: 0,
            recentlyAddedStartups: [],
            enterprisesCount: {
                invited: 0,
                connected: 0,
            },
            enterprisesLoaded: false,
        }
    },

    mounted() {
        this.updateAll()

        this.$store.watch(state => {
            if (state.needUpdateStartups) {
                this.updateStartups()
            }

            if (state.needUpdateEnterprises) {
                this.updateEnterprisesCount()
            }
        })
    },

    methods: {
        updateAll() {
            this.updateStartups()
            this.updateEnterprisesCount()
        },

        updateStartups() {
            dashboard.getAppliedStartupsCount().then(response => {
                this.appliedStartupsCount = response.data
                this.startupsLoaded = true
            })

            dashboard.getRecentlyAddedStartups().then(response => {
                this.recentlyAddedStartups = response.data
            })

            dashboard.getAddedStartupsCount().then(response => {
                this.addedStartupsCount = response.data
            })
        },

        updateEnterprisesCount() {
            dashboard.getEnterprisesCount().then(response => {
                this.enterprisesCount = response.data
                this.enterprisesLoaded = true
            })
        },

        addStartup() {
            this.$store.commit('setAddStartup', true);
            this.$nextTick(() => {
                this.$store.commit('setAddStartup', false);
            })
        },

        addEnterprise() {
            this.$store.commit('setAddEnterprise', true);
            this.$nextTick(() => {
                this.$store.commit('setAddEnterprise', false);
            })
        },

        openCompanyProfile() {
            this.$store.commit('setOpenCompanyProfile', true);

            this.$nextTick(() => {
                this.$store.commit('setOpenCompanyProfile', false);
            })
        },
    }
}
</script>
